import React from 'react';
import { PapiDeviation } from '@wix/da-papi-types';
import { normalizePremiumFolderData } from '../../../utils/normalizePremiumFolderData';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import PremiumGallery from '@wix/da-ds/pkg/Icons/24x24/PremiumGallery';
import EyeDisc2 from '@wix/da-ds/pkg/Icons/16x16/EyeDisc2';
import MultiImage from '@wix/da-ds/pkg/Icons/16x16/MultiImage';
import PromoBadge from '@wix/da-ds/pkg/Badges/PromoBadge';
import { useSubscriptionTier } from '../../../utils/hooks/useSubscriptionTier';
import { isMultiImageDeviation } from '../../../DeviationViews/_helpers';

export interface Props {
  deviation: PapiDeviation;
  className?: string;
}

const IndicatorForDeviationThumb: React.FC<Props> = ({
  deviation,
  className,
}) => {
  const { isPremium, isPaidFolder, isWatchToAccess } =
    normalizePremiumFolderData(deviation?.premiumFolderData);

  const { isInTier } = useSubscriptionTier(deviation);
  const isMultiImage = isMultiImageDeviation(deviation);

  let indicator;
  if (isPremium) {
    if (isPaidFolder) {
      indicator = <PremiumGallery size={IconSize.SMALL} />;
    } else if (isWatchToAccess) {
      indicator = <EyeDisc2 size={IconSize.SMALL} />;
    }
  } else if (isInTier) {
    indicator = <PromoBadge badgeType="tier" size={16} />;
  } else if (isMultiImage) {
    indicator = <MultiImage size={IconSize.SMALL} />;
  }

  return indicator ? <div className={className}>{indicator}</div> : null;
};
IndicatorForDeviationThumb.displayName = 'IndicatorForDeviationThumb';

export default IndicatorForDeviationThumb;
